<template>
  <div class="wrapper is-flex is-flex-direction-column is-justify-content-center is-align-items-center flex-gap-10">
    <div class="title is-size-6">{{ title }}</div>
    <div class="subtitle is-size-3" id="number">{{ count }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
}
</style>
